import {
  FormFieldWidget,
  ModelFieldType,
  SPI,
  ViewType,
  Widget,
  FormO2MTableFieldWidget,
  SubmitRelationValue,
  SubmitValue,
  ActiveRecord
} from '@kunlun/dependencies';
import Comp from './OrderPlanProductDetail.vue';
import { queryPage } from './services';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: ModelFieldType.OneToMany,
    widget: 'Table',
    name: 'deliAriesBuyerPurchasingPlanDetails',
    multi: true
  })
)
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: ModelFieldType.OneToMany,
    widget: 'Table',
    name: 'deliAriesSellerPurchasingPlanDetailList',
    multi: true
  })
)
export class FormOrderPlanProductDetailFieldWidget extends FormO2MTableFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Reactive()
  private state: {
    tableLoading: boolean;
  } = {
    tableLoading: false
  };

  @Widget.Method()
  private setState(val: Partial<typeof this.state>) {
    Object.assign(this.state, val);
  }

  @Widget.Reactive()
  get rModel() {
    return this.runtimeSubviewContext.model;
  }

  @Widget.Reactive()
  get _field() {
    return this.field;
  }

  @Widget.Reactive()
  private mountedProcessFlag = false;

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  protected async mountedProcess() {
    await this.initData();
    this.mountedProcessFlag = true;
  }

  protected async initData() {
    this.state.tableLoading = true;
    try {
      const res = await queryPage(this.model, {
        orderCode: this.formData.orderCode as string,
        purchasingPlanId: this.formData.id as number
      });
      this.change(res || []);
    } finally {
      this.state.tableLoading = false;
    }
  }

  submit(submitValue: SubmitValue): Promise<SubmitRelationValue | Record<string, unknown> | undefined> {
    // 提交时过滤掉本次要货数量为0的数据
    const res = this.value!.filter((item: any) => item.itemPurchasingNum > 0);
    this.change(res);
    return super.submit(submitValue);
  }
}
